import Carousel from './Carousel.vue'
import CarouselItem from './CarouselItem.vue'

export default {
  Carousel,
  CarouselItem
}



// WEBPACK FOOTER //
// ./src/components/carousel/index.js